<template>
  <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Galery</strong> Form
          </div>
          <b-form v-on:submit.prevent="submitFile()">
            <b-form-group
              label="Name"
              label-for="name"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="name" type="text"  autocomplete="name" required class="form-control-warning" v-model="data.name"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Photo"
              label-for="photo"
              description=""
              :label-cols="3"
              :horizontal="true">
              <b-form-file id="photo" ref="file" placeholder="Enter photo.." autocomplete="photo" class="form-control-warning" @change="onFileChange" accept="image/*"></b-form-file>              
            </b-form-group>
            <div class="form-group">
              <div class="form-row">
                <label id="__BVID__244__BV_label_" for="password" class="col-sm-3 col-form-label"></label>
                <div class="col-sm-9">              
                  <!--
                  <b-progress :value="uploadPercentage" :max="100" show-progress animated  v-if="!image"></b-progress>
                  -->
                  <img :src="data.img_prev" class="" style="margin-top:20px;width:100%;"   />
                </div>
              </div>
            </div>
            <div slot="footer">
              <div class="form-row">
                <div class="col-sm-3">
                  
                </div>
                <div class="col-sm-9">
                  <b-button type="submit" size="sm" variant="primary" :disabled="isLoading" > Submit</b-button>
                  <b-button type="button" @click="goBack" size="sm" variant="danger" :disabled="isLoading">Back</b-button>
                </div>
              </div>

            </div>
          </b-form>
        </b-card>
      </b-col>
      
      <BlockUI message="loading" v-if="isLoading">
        <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
      </BlockUI>
  </b-row>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  name: 'Galery',
  components: {
      VueEditor
   },
  props: {
    caption: {
      type: String,
      default: 'Galery '
    },
  },
  
  mounted() {
    this.id = this.$route.params.id;
    if(this.id !== undefined){
      this.getData(this.id);
    }
  },
  data: () => {
    return {
      error: false,
      data: {
        name: '',
      },
      image:'',
      file:'',
      uploadPercentage :0,
      msg : '',
      id:'',
      msg_type : '',
      isLoading:false,
    }
    
  },
  methods: {
    getData(id){
      var app = this;
      var url = this.end_point+'galery/'+id;
      app.isLoading = true;
      axios.get(url, {})
        .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
        }else{
          app.data = resp.data.data;
          if(resp.data.data.prev_img){
            //alert(resp.data.row.prev_img);
            app.image = resp.data.data.prev_img;
          }
        }
      })
      .catch(function (resp) {
        console.log(resp);
        app.isLoading=false;
        // app.$notify.error(app.setting.msg_con);
        app.error = true;
      });  
    },
    saveForm() {
      var app = this;
      var newDt = app.data;
      var url = this.end_point;

      var api = '';
      if(this.id === undefined){
        url += 'galery';
        api = axios.post(url, newDt);
      }else{
        url += 'galery/'+this.id;
        api = axios.put(url, newDt);
      }
      app.isLoading=true;
      api
      .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
          window.scrollTo(0,0);
        }else{
          app.$notify.success(resp.data.msg);
          app.$router.replace(`/galery`);
        }
      })
      .catch(function (resp) {
        app.isLoading=false;
        app.$notify.error(app.setting.msg_con);
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    submitFile(){
      let formData = new FormData();
      if(!this.file){
        this.saveForm();
        return;
      }
      formData.append('file', this.file);
      formData.append('name', this.data.name);
      var app  = this;
      app.isLoading=true;
      axios.post( this.end_point+'galery/upload',formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function( progressEvent ) {
          this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
        }.bind(this)
      }).then(function(e){
        
        app.isLoading=false;
        console.log(e);
        if(e.data.error){
          app.msg = e.data.msg;
          app.msg_type = 'danger';
          return false;
        }
        app.msg='';
        // app.data.img_prev = e.data.file_path;     
        app.data.img = e.data.data;  

        app.saveForm();     
        // app.createImage(app.file);
      })
      .catch(function(e){
          app.isLoading=false;
          app.msg = 'upload filed please try again';
          app.$notify.error(app.msg);
          app.msg_type = 'danger';
      });
    },
    onFileChange(e){
      this.image= '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){      
          return;
      }
      this.file = files[0];
      // this.submitFile();
      this.createImage(this.file);
    },
    createImage(file) {
      const FileSize = file.size / 1024 / 1024;
      console.log(FileSize, 'size');
      if (FileSize > 2) {
        //this.global.presentAlert('ukuran maksimal 2MB');
        //return false;
      }
      const image = new Image();
      const reader = new FileReader();
      //this.data.img_prev = null;

      const vm = this;
      reader.onload = e => {
        vm.data.img_prev = reader.result;
        console.log(vm.data);
      };
      reader.readAsDataURL(file);

      this.file = file;
      console.log(this.file);
      console.log(this.data.img_prev);
      
      
    },
  }
}
</script>
